function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "home-mid_svg__a",
  "data-name": "Home_ic_mic 2",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M82 122h28v52H82z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M158 94h16l-16-16V30h-24v24l-31-32.5c-4.28-4.56-9.9-4.38-14 0L18 94h16v70a10 10 0 0010 10h104a10 10 0 0010-10z",
  fill: "none",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "Home_ic_mic 2",
  width: 192,
  height: 192,
  xlinkHref: "#home-mid_svg__a"
}));

var SvgHomeMid = function SvgHomeMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgHomeMid;